module.exports = __webpack_public_path__ + "static/Process-hero-0d15741ca9f43aa20f6b4d69b0886957.jpg";